module.exports = __webpack_public_path__ + "img/coupon.aa65508f.png";